import { render, staticRenderFns } from "./Kategori.vue?vue&type=template&id=8111d120&"
import script from "./Kategori.vue?vue&type=script&lang=js&"
export * from "./Kategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports